import { SIZES, shieldMm, eur } from "../../lib/shield";
import { CompareSizes } from "../CompareSizes";
import { SeeOnWall } from "../WallPreview";

export const SizePanel = ({ size, design, onChange }) => (
  <div className="space-y-3">
    <div className="grid grid-cols-2 gap-2 xl:grid-cols-4">
      {SIZES.map((s) => {
        const m = shieldMm(s);
        const active = (size || "medium") === s.id;
        return (
          <button key={s.id} type="button" onClick={() => onChange(s.id)} data-testid={`size-option-${s.id}`} aria-pressed={active}
            className={`flex flex-col items-start border-2 p-3 text-left transition-[border-color,transform] hover:-translate-y-0.5 ${active ? "border-slate-900 bg-lime-50 shadow-[3px_3px_0_0_#0f172a]" : "border-slate-200 bg-white hover:border-slate-900"}`}>
            <span className="font-display text-base font-extrabold uppercase">{s.name}</span>
            <span className="font-mono-cc text-xs text-slate-600">Shield size {m.w} × {m.h} mm</span>
            {s.recommended && <span className="mt-1 bg-lime-400 px-1.5 py-0.5 text-[10px] font-black uppercase text-slate-900" data-testid={`size-recommended-${s.id}`}>Recommended</span>}
            <span className="font-cond mt-1 text-xl font-bold" data-testid={`size-price-${s.id}`}>{eur(s.price)}</span>
          </button>
        );
      })}
    </div>
    <div className="flex flex-wrap gap-x-5 gap-y-2"><CompareSizes active={size || "medium"} />{design && <SeeOnWall design={design} size={size || "medium"} />}</div>
    <p className="text-xs text-slate-500">The size is the board. Your shield fills its full height, keeps its exact cut shape and is centred. Prices include VAT.</p>
  </div>
);
